import { FC } from 'react';
import KpiCard, { KpiTone } from '../../../../shared/KpiCard/KpiCard';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamReturnConfidenceMetric } from '../../../../models/injury';

interface Props {
  data: ITeamReturnConfidenceMetric | null;
}

/** Fiducia bassa (<4) = danger, media (4-6.9) = warning, alta (>=7) = neutral (nessun allarme). */
function toneFromConfidence(conf: number | null): KpiTone {
  if (conf == null) return 'neutral';
  if (conf < 4) return 'danger';
  if (conf < 7) return 'warning';
  return 'neutral';
}

export const TeamReturnConfidenceCard: FC<Props> = ({ data }) => {
  const entry = data?.data?.[0];
  if (!entry || entry.activeInjuriesCount === 0) return <ChartEmptyState />;

  const conf = entry.avgConfidence;
  const sub = `Su ${entry.activeInjuriesCount} infortuni attivi${
    entry.athletesWithData < entry.activeInjuriesCount ? ` (${entry.athletesWithData} con dati)` : ''
  }`;

  return (
    <KpiCard
      label="Confidenza media"
      value={conf != null ? `${conf.toFixed(1)}/10` : '–'}
      tone={toneFromConfidence(conf)}
      sub={sub}
    />
  );
};
